export default "__VITE_ASSET__9a7b55da__"